import { useState } from 'react';
import { authFetch } from '../services/authFetch';
import { useAuth } from '../context/AuthContext';

export default function FeedbackModal({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const { token, login, logout } = useAuth();

  const handleSubmit = async () => {
    try {
      const response = await authFetch(
        `${import.meta.env.VITE_BASE_URL}/api/feedback`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        },
        { token, login, logout }
      );

      if (!response.ok) {
        console.error('Feedback submission failed');
      }

      setSubmitted(true);
      // Wait before closing modal to show "thank you" state
      setTimeout(onClose, 1500);
    } catch (err) {
      console.error('Error submitting feedback:', err);
    }
  };

  const handleReviewClick = async () => {
    await handleSubmit();
    window.open('https://uk.trustpilot.com/review/dialvia.com', '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex justify-center items-center z-50">
  <div className="relative bg-white text-gray-900 rounded-2xl shadow-xl max-w-md w-full p-6 border border-purple-200">
    <button
      onClick={onClose}
      className="absolute top-4 right-4 text-sm text-purple-600 hover:text-purple-500 underline"
    >
      Close
    </button>

    {submitted ? (
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2 text-purple-600">
          Thank you! 🎉
        </h2>
        <p className="text-sm text-gray-700">
          We really appreciate your feedback.
        </p>
      </div>
    ) : (
      <>
        <h2 className="text-2xl font-semibold text-purple-600 mb-2">
          How was your call?
        </h2>
        <p className="text-sm text-gray-700 mb-6">
          Your feedback helps us improve DialVia.
        </p>

        <button
          onClick={handleReviewClick}
          className="w-full py-2 mb-4 rounded-xl font-medium text-sm bg-white text-green-700 border border-green-500 hover:bg-green-50 transition-all flex items-center justify-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-green-600"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 2l3.09 6.26L22 9.27l-5.45 5.32L18.18 22 12 18.27 5.82 22l1.63-7.41L2 9.27l6.91-1.01L12 2z" />
          </svg>
          Review us on Trustpilot
        </button>

        <button
          onClick={onClose}
          className="w-full py-2 rounded-xl font-medium text-sm transition-all bg-gray-100 hover:bg-gray-200 text-gray-900"
        >
          No Thanks
        </button>
      </>
    )}
  </div>
</div>

  );
}
